import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class MenuItem  {
    _originalTypeClassName = "ekylikeio.BO.MenuItem";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
MenuItem.translate = translateService;
}
this.menuItemToOrderItem = [];
this.Tags = [];
this.Id = null;
this.Name = null;
this.Description = null;
this.Price = null;
this.Available = false;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Name:any;
Description:any;
Price:any;
Available:any;
menuItemToOrderItem:any;
Category:any;
Image:any;
Tags:any;
static setmenuItemToOrderItem = ($this, items) => {
                if (items == null) items = [];
                if ($this.menuItemToOrderItem == null) $this.menuItemToOrderItem = [];

                const copyItems = Common.cloneObject(items);

                while ($this.menuItemToOrderItem.length > 0) {
                    Domain.MenuItem.removemenuItemToOrderItem($this, $this.menuItemToOrderItem[0]);
                }

                Domain.MenuItem.addManymenuItemToOrderItem($this, copyItems);
            }
static addManymenuItemToOrderItem = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.MenuItem.addmenuItemToOrderItem($this, items[i]);
                }
            }
static addmenuItemToOrderItem = ($this, item) => {
                if ($this.menuItemToOrderItem == null) $this.menuItemToOrderItem = [];
                if (item == null || $this.menuItemToOrderItem.indexOf(item) > -1) return;
                $this.menuItemToOrderItem.push(item);
if (item.MenuItem != $this) {
Domain.OrderItem.setMenuItem(item, $this);
}
}
static addRangemenuItemToOrderItem = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.MenuItem.addmenuItemToOrderItem($this, item));
            }
static removemenuItemToOrderItem = ($this, item) => {
                if ($this == null || $this.menuItemToOrderItem == null || $this.menuItemToOrderItem.indexOf(item) === -1) return;
                var _index = $this.menuItemToOrderItem.indexOf(item);
                $this.menuItemToOrderItem.splice(_index, 1);
item.MenuItem = null;
}
static clearmenuItemToOrderItem = ($this) => { $this.menuItemToOrderItem = null; }
static setCategory = ($this, value) => {
var oldValue = $this.Category;
$this.Category = value;
if (value != null) {
}
}
static setImage = ($this, value) => {
var oldValue = $this.Image;
$this.Image = value;
if (value != null) {
}
}
static setTags = ($this, items) => {
                if (items == null) items = [];
                if ($this.Tags == null) $this.Tags = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Tags.length > 0) {
                    Domain.MenuItem.removeTags($this, $this.Tags[0]);
                }

                Domain.MenuItem.addManyTags($this, copyItems);
            }
static addManyTags = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.MenuItem.addTags($this, items[i]);
                }
            }
static addTags = ($this, item) => {
                if ($this.Tags == null) $this.Tags = [];
                if (item == null || $this.Tags.indexOf(item) > -1) return;
                $this.Tags.push(item);
}
static addRangeTags = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.MenuItem.addTags($this, item));
            }
static removeTags = ($this, item) => {
                if ($this == null || $this.Tags == null || $this.Tags.indexOf(item) === -1) return;
                var _index = $this.Tags.indexOf(item);
                $this.Tags.splice(_index, 1);
}
static clearTags = ($this) => { $this.Tags = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}